import CompetetionCourseListing from '../feature/LeaderBoard/CompetetionCourseListing'

const CompetetionCourseListingPage = () => {
  return (
    <CompetetionCourseListing />
  )
}

export default CompetetionCourseListingPage
